import { formatMoney } from '@shopify/theme-currency';
import { selectNewFilter, getCurrentPage } from './filtering';
import { handleize } from '../../core/helpers';

/* IMPORTANT: Doesn't apply to the search overlay */

const getSortingState = () => {
  const saved_filters = JSON.parse(window.localStorage.getItem('wild-filter'));
  const previous_page = window.localStorage.getItem('previous-page') || '';

  const $sorting_container = (window.theme.breakpoints.current === 'mobile') ? $('[data-mobile-filter-sorting]') : $('[data-show-desktop-sort-nav]').parent().find('[data-sort-by]');
  const sortby_name = (window.theme.breakpoints.current === 'mobile') ? 'sortby-mobile' : 'sortby';
  
  if (saved_filters === null || !previous_page.includes('/products/') || $('body').hasClass('template-search')) {
    let sortby_value = $sorting_container.find(`input[name="${sortby_name}"]:checked`).val();

    if (typeof sortby_value === 'undefined' || !sortby_value.length) {
      sortby_value = 'manual';
    }
    
    // Assign the same sorting to desktop and mobile
    $sorting_container.find(`input[value="${sortby_value}"]`).prop('checked', true);
    $(`[data-mobile-filter-sorting] input[value="${sortby_value}"]`).prop('checked', true);

    return sortby_value;
  }

  // Assign the same sorting to desktop and mobile
  $sorting_container.find(`input[value="${saved_filters.sort_by}"]`).prop('checked', true);
  $(`[data-mobile-filter-sorting] input[value="${saved_filters.sort_by}"]`).prop('checked', true);
  return saved_filters.sort_by;
};

// Save local storage everytime a filter is selected
const saveFilterState = () => {
  if (!$('body').hasClass('template-collection')) {
    return;
  }

  window.localStorage.removeItem('wild-filter');

  const filter_options = {
    page: getCurrentPage(),
    sort_by: '',
  };

  filter_options.sort_by = getSortingState();

  // Push the selected option dynamically (since we now have dynamic filters)
  _.each($('[data-filter-options]'), (option) => {
    const $active_options = $(option).find('[data-clickable-option].active');

    if (typeof $active_options !== 'undefined' && $active_options.length) {
      const group_name = $(option).data('filter-options-type');

      _.each($active_options, (active_option) => {
        if (typeof filter_options[group_name] === 'undefined') {
          filter_options[group_name] = [];
        }

        const add_value = $(active_option).data('option-value');
        // We can have duplicates since we have multiple filter components on the page
        if (filter_options[group_name].indexOf(add_value) === -1) {
          filter_options[group_name].push($(active_option).data('option-value'));
        }
      });
    }
  });

  window.localStorage.setItem('wild-filter', JSON.stringify(filter_options));
};

const getPaginationState = () => {
  const saved_filters = JSON.parse(window.localStorage.getItem('wild-filter'));

  if (saved_filters === null) {
    return 1;
  }
  
  return saved_filters.page;
};

// Apply the saved filters when coming back from the product page OR after selecting it from the sort by feature
// CODE DOESN'T APPLY TO SEARCH OVERLAY
const applyFilterState = async (from_product_page_only = false) => {
  const saved_filters = JSON.parse(window.localStorage.getItem('wild-filter'));
  const previous_page = window.localStorage.getItem('previous-page') || '';

  console.log('[wild-filter]', saved_filters, previous_page);
  window.localStorage.removeItem('wild-filter');

  if (from_product_page_only) {
    if (saved_filters === null || !previous_page.includes('/products/') || $('body').hasClass('template-search')) {
      // await selectNewFilter(false);
      console.log('[wild-filter] don\'t apply');
      return false;
    }

    console.log('[wild-filter] apply');
  }

  document.querySelectorAll('[data-selected-filters-list] [data-selected-filters-item]').forEach(item => item.remove());

  for (const saved_filter in saved_filters) {
    if ($(`[data-filter-options-type="${saved_filter}"]`).length) {
      _.each($(`[data-filter-options-type="${saved_filter}"] [data-clickable-option]`), (option) => {
        $(option).removeClass('active');
        $(option).parent().removeClass('active');

        // The following will happen twice since we have desktop and mobile options
        _.each(saved_filters[saved_filter], (saved_option) => {
          if (saved_option === $(option).data('option-value') && !$(option).hasClass('active')) {
            $(option).addClass('active');
            $(option).parent().addClass('active');

            let saved_option_value = saved_option;
            if (saved_option_value.includes('vt::')) {
              saved_option_value = _.last(saved_option_value.split('::'));
            }

            // if (saved_option_value.includes('USD:')) {
            //   saved_option_value = saved_option_value.replace(new RegExp('USD:', 'g'), '$');
            // }

            if (saved_filter === 'price') {
              // saved_option_value = `${currency_symbol}${saved_option_value.replace(':', `-${currency_symbol}`)}`;
              const price_range_parts = saved_option_value.split('-');
              saved_option_value = `${formatMoney(Math.ceil(Number(price_range_parts[0]) * window.Shopify.currency.rate) * 100, theme.moneyFormat).replace('.00', '').replace(',00', '')}-${formatMoney(Math.ceil(Number(price_range_parts[1]) * window.Shopify.currency.rate) * 100, theme.moneyFormat).replace('.00', '').replace(',00', '')}`;
            }

            // Also add the selected option flag
            if (!$(`[data-selected-filters-type="${saved_filter}"][data-selected-filters-value="${saved_option}"]`).length) {
              const selected_filter_item_html = `
                <div class="selected-filters__item"
                  data-selected-filters-item
                  data-selected-filters-short-value="${handleize(saved_option)}"
                  data-selected-filters-type="${saved_filter}"
                  data-selected-filters-value="${saved_option}"
                  role="button"
                  tabindex="0">
                  ${saved_option_value}
                </div>
              `;

              // $('[data-selected-filters-list]').append(selected_filter_item_html);
              $(selected_filter_item_html).insertBefore(`[data-selected-filters-list] [data-clear-all-filters]`);
            }
          }
        });
      });
    }
  }

  const filter_container = document.querySelector('[data-collection-grid-container] [data-selected-filters]');
  const has_selected_filters = filter_container.querySelectorAll('[data-selected-filters-item]').length > 0;
  filter_container.classList.toggle('active', has_selected_filters);

  // Apply the filters
  const saved_page = (typeof saved_filters.page === 'undefined') ? 1 : saved_filters.page;
  if (saved_page > 1) {
    // await selectNewFilter(false, true, saved_page * per_page);
    await selectNewFilter(false, true, saved_page);
  } else {
    await selectNewFilter(false, true);
  }

  return true;
};

export {
  saveFilterState,
  applyFilterState,
  getSortingState,
  getPaginationState,
};
